
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Bookinnovaforoutstationfrompune() {



    const cardData =
    {
        keyword: 'Book Innova for Outstation from Pune',
        heading: 'S9 Travels: Book Innova for Outstation from Pune',
        headingDescription: 'S9 Travels offers convenient and reliable Innova cab services for outstation trips from Pune. Whether you are planning a long-distance journey to popular destinations like Mahabaleshwar, Lonavala, Alibaug, or any other outstation destination, our fleet of well-maintained Innova cabs is ready to provide you with a comfortable and hassle-free experience.',

        top: 'Top Places to Visit in Pune with S9 Travels',

"topPlaces": [
    {
      "title": "Shaniwar Wada",
      "description": "A historic fortification in the heart of Pune, Shaniwar Wada was the seat of the Peshwa rulers. It is famous for its beautiful architecture, impressive gates, and rich history. Don't miss the sound and light show in the evening."
    },
    {
      "title": "Aga Khan Palace",
      "description": "A stunning piece of architecture, the Aga Khan Palace is a historical monument and also a site where Mahatma Gandhi was imprisoned during the British colonial rule. It houses a museum that showcases artifacts related to India's independence struggle."
    },
    {
      "title": "Sinhagad Fort",
      "description": "Located around 30 km from Pune, Sinhagad Fort is a popular trekking spot with historical significance. The fort offers panoramic views of the surrounding area and is known for its role in Maratha history."
    },
    {
      "title": "Osho Ashram",
      "description": "The Osho International Meditation Resort is a serene place for those looking for spiritual healing and tranquility. The ashram offers various meditation programs and is set in lush green surroundings."
    },
    {
      "title": "Fergusson College",
      "description": "A heritage institution in Pune, Fergusson College is one of the oldest colleges in the city and offers a beautiful campus with colonial-era architecture. The college grounds are perfect for a peaceful walk."
    },
    {
      "title": "Pataleshwar Cave Temple",
      "description": "A rock-cut temple dedicated to Lord Shiva, Pataleshwar is an ancient temple located in the heart of Pune. The temple's unique architecture and peaceful ambiance make it a great spot for history and architecture enthusiasts."
    },
    {
      "title": "Raja Dinkar Kelkar Museum",
      "description": "This museum showcases a fascinating collection of Indian artifacts, including sculptures, musical instruments, and traditional art pieces. It’s a great place to explore Pune's rich cultural heritage."
    },
    {
      "title": "Koregaon Park",
      "description": "Known for its vibrant atmosphere, Koregaon Park is home to Osho Ashram, chic cafes, and boutique shops. It’s a lovely place to stroll around and enjoy a laid-back evening."
    },
    {
      "title": "Mulshi Lake and Dam",
      "description": "About 40 km from Pune, Mulshi Lake is a peaceful getaway with stunning views of the surrounding hills and nature. It’s perfect for nature lovers, photographers, and those seeking a quiet retreat."
    },
    {
      "title": "Vishrambaug Wada",
      "description": "Another historical building, Vishrambaug Wada was once the residence of the Peshwa rulers. It is an architectural gem with beautiful wooden carvings and a glimpse into Pune's royal past."
    }
],

"services": [
    {
      "name": "Book Outstation Innova Cab from Pune",
      "description": "Looking for a premium and comfortable Innova taxi for outstation travel? Book an Innova cab from Pune for your next trip and enjoy a smooth and luxurious ride, no matter how far your destination is."
    },
    {
      "name": "Pune to Outstation Innova Taxi Booking",
      "description": "Plan your outstation travel from Pune with an Innova taxi. Whether you’re heading to a nearby city or a longer distance, we offer easy Innova cab booking for your comfort and convenience. Get started by choosing from one-way or round-trip options to suit your needs."
    },
    {
      "name": "Book Innova Taxi for Long Distance from Pune",
      "description": "Need a taxi for a long-distance journey? Our Innova taxis are perfect for long-haul travel, offering comfort, ample space, and reliability. Whether it’s a road trip or a business trip, our long-distance Innova cabs ensure a hassle-free and enjoyable journey."
    },
    {
      "name": "Pune Outstation Innova Rental",
      "description": "Rent an Innova car for your outstation trip from Pune. With flexible rental options, you can enjoy the freedom to explore your destination at your own pace. Our Innova rentals are ideal for individuals, families, or groups traveling out of Pune."
    },
    {
      "name": "Pune Outstation Innova Car Hire",
      "description": "For your outstation travel needs from Pune, hire an Innova and travel comfortably in style. We offer competitive rates, professional drivers, and well-maintained vehicles for all your outstation trips."
    },
    {
      "name": "Innova Cabs for Outstation Travel from Pune",
      "description": "Travel in comfort and style with Innova cabs for your outstation trips from Pune. Whether it’s a family getaway, a business trip, or a sightseeing tour, our Innova cabs are equipped with top-notch amenities for a pleasant journey."
    },
    {
      "name": "Outstation Travel by Innova from Pune",
      "description": "Travel to your desired outstation destination in style with our Innova cabs. Whether you’re going to Mumbai, Goa, or anywhere else, our Innova taxis offer a comfortable and convenient way to explore new places."
    },
    {
      "name": "Book Innova Cab for Weekend Outstation",
      "description": "Planning a weekend getaway? Book an Innova cab for a weekend outstation trip from Pune. Enjoy your short escape with your loved ones while our professional drivers take care of the road, ensuring a stress-free and fun-filled journey."
    },
    {
      "name": "Pune Outstation Taxi Service",
      "description": "Our Pune outstation taxi service is designed for travelers who need a reliable and affordable mode of transport. Whether it’s a one-day trip or a long holiday, we provide exceptional service to ensure your outstation journey is seamless."
    },
    {
      "name": "Affordable Innova Outstation Booking",
      "description": "Get the best rates for your Innova outstation taxi from Pune! We offer affordable pricing for both one-way and round-trip bookings. With no hidden charges, you can enjoy your trip at a price that fits your budget."
    },
    {
      "name": "Private Innova for Outstation from Pune",
      "description": "For added convenience, choose a private Innova for your outstation travel from Pune. You can enjoy complete privacy, flexibility, and personalized service, making it the perfect option for families, friends, or solo travelers."
    },
    {
      "name": "Pune to Outstation Travel in Innova",
      "description": "Whether you’re traveling to Goa, Mumbai, Lonavala, or any other outstation destination from Pune, our Innova taxis are available for a smooth and comfortable ride. Book your outstation travel in Innova today!"
    },
    {
      "name": "Book Innova Car for Outstation Tour",
      "description": "Planning a long-distance tour? Book an Innova car for your outstation tour from Pune. Whether it’s a sightseeing tour or a business trip, our Innova taxis provide ample space and comfort to make your journey enjoyable."
    },
    {
      "name": "Group Travel with Innova for Outstation",
      "description": "Traveling with a group? Our Innova cabs are the perfect choice for group outstation travel from Pune. With seating for 6-7 passengers and plenty of luggage space, you and your group can travel together in comfort and style."
    },
    {
      "name": "Pune to Goa Outstation Innova",
      "description": "Going to Goa from Pune? Book an Innova taxi for your Goa trip! Whether you’re planning a short trip or an extended stay, our Innova cabs provide a relaxing and spacious way to travel to Goa from Pune."
    }
  ],

"tableData": [
  ["Book Outstation Innova Cab from Pune", "Pune to Outstation Innova Taxi Booking"],
  ["Book Innova Taxi for Long Distance from Pune", "Pune Outstation Innova Rental"],
  ["Pune Outstation Innova Car Hire", "Innova Cabs for Outstation Travel from Pune"],
  ["Outstation Travel by Innova from Pune", "Book Innova Cab for Weekend Outstation"],
  ["Pune Outstation Taxi Service", "Affordable Innova Outstation Booking"],
  ["Private Innova for Outstation from Pune", "Pune to Outstation Travel in Innova"],
  ["Book Innova Car for Outstation Tour", "Group Travel with Innova for Outstation"],
  ["Pune to Goa Outstation Innova", ""]
],
"whychoose": [
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "At S9 Travels, we understand that time is precious, especially when traveling for outstation trips. Whether it's a weekend getaway, business trip, or family vacation, we guarantee timely pickups and drop-offs. Our drivers are always punctual and ensure your journey is smooth and efficient."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Vehicles",
    "WhyChoosedescription": "Our Toyota Innova cabs are ideal for long-distance outstation journeys. With spacious interiors, plush seating, and air conditioning, the Innova ensures a comfortable and enjoyable ride. Whether you’re traveling with family or friends, everyone will have a relaxing journey."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our drivers are well-trained and experienced in handling long-distance outstation trips. They are familiar with the best routes and ensure a safe and smooth journey, providing you with helpful assistance along the way."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers competitive pricing for outstation Innova bookings. We ensure full transparency in pricing, with no hidden charges. A clear breakdown of all costs is provided upfront, so you can travel with peace of mind knowing exactly what you’re paying for."
  },
  {
    "WhyChooseheading": "Safe and Comfortable Journey",
    "WhyChoosedescription": "Safety is our top priority. Our Toyota Innova vehicles come equipped with modern safety features, such as airbags, seat belts, and GPS tracking. We want to ensure that your outstation trip is not only comfortable but also secure."
  },
  {
    "WhyChooseheading": "24/7 Availability",
    "WhyChoosedescription": "No matter when you plan your outstation trip from Pune, S9 Travels is available 24/7. Whether it's an early morning departure or a late-night return, we are ready to serve you. Our customer service team is also available round-the-clock to assist with bookings and any inquiries."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Booking an Innova for outstation travel from Pune is easy with S9 Travels. You can book your cab online via our website or mobile app, or reach out to our customer service team for personalized assistance with your booking."
  },
  {
    "WhyChooseheading": "Customized Travel Packages",
    "WhyChoosedescription": "We offer customized travel packages for your outstation trips. Whether it’s a trip to a nearby hill station, a pilgrimage, or a corporate visit, we tailor the trip to suit your needs, ensuring a memorable and comfortable experience."
  }
]



























    }



    const faqData = [
        [
          {
            question: 'How can I book an Innova cab for an outstation trip from Pune with S9 Travels?',
            answer: 'You can book an Innova cab for your outstation trip online via our website or mobile app, or you can contact our customer service team for assistance with your booking.',
          },
          {
            question: 'What is the seating capacity of the Innova?',
            answer: 'The Toyota Innova comfortably seats up to 6 passengers, making it ideal for family trips, group outings, or business travel.',
          },
          {
            question: 'Are the drivers experienced for long-distance outstation travel?',
            answer: 'Yes, our drivers are highly experienced in long-distance travel and know the best routes to ensure a safe, smooth, and efficient journey to your destination.',
          },
          {
            question: 'What payment options are available for booking an Innova for an outstation trip?',
            answer: 'We offer flexible payment options, including cash, credit/debit cards, and online payments through our app for your convenience.',
          },
          {
            question: 'Can I book a round-trip Innova for an outstation journey?',
            answer: 'Yes, we can arrange a round-trip booking for you. Just provide us with your return details, and we’ll ensure that your return journey is just as comfortable and timely.',
          },
          {
            question: 'Are there any extra charges for waiting or detours during the trip?',
            answer: 'Any additional charges, such as for waiting time or detours, will be communicated to you upfront. We ensure complete transparency in pricing so that you are aware of any extra charges beforehand.',
          },
          {
            question: 'Can I use the Innova for sightseeing during my outstation trip?',
            answer: 'Yes, our Innova cabs are available for sightseeing tours. Explore popular tourist attractions or visit specific locations with the comfort of a spacious and well-maintained vehicle.',
          },
          {
            question: 'What is the luggage allowance for an Innova cab?',
            answer: 'The Toyota Innova offers ample space for standard luggage. If you have more luggage or specific requirements, please let us know during the booking process, and we’ll accommodate your needs.',
          },
          {
            question: 'Is S9 Travels available for corporate or group travel with Innova cabs?',
            answer: 'Yes, we provide Innova cabs for corporate travel, team outings, and group travel. We ensure a comfortable and professional experience for everyone in your group.',
          },
          {
            question: 'Why should I choose S9 Travels for my outstation Innova cab booking from Pune?',
            answer: 'S9 Travels offers a reliable, comfortable, and affordable journey with professional drivers, well-maintained vehicles, and excellent customer service. We ensure that your outstation trip is safe, smooth, and enjoyable.',
          },
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Ashish Patil',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“I booked an Innova cab with S9 Travels for a family trip to a nearby hill station. The vehicle was spacious and well-maintained, and the driver was experienced and friendly. We had a smooth, enjoyable journey. Highly recommend S9 Travels for outstation trips!”',
        },
        {
          name: 'Mrs. Neha Deshmukh',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“Our corporate group booked an Innova for an outstation trip, and we had a wonderful experience. The vehicle was comfortable, and the driver was professional. Everything was well-organized, and we reached our destination on time. Will definitely book with S9 Travels again!”',
        },
      ];
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   
      
    const productSchema = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Book Innova for Outstation From Pune",
        "description": "Book an Innova for outstation travel from Pune with S9 Travels. Offering long-distance Innova taxi booking for your outstation trips, affordable Innova rental, and private car hire services. Book now for weekend getaways, group travel, and more!",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.8",
          "ratingCount": "7654"
        }
      };
      
   
      
      


    return (
        <div>
            <Helmet>
        <title>Book Innova for Outstation from Pune | Affordable & Luxury Innova Outstation Cabs | S9 Travels | Contact: +91 8850328441</title>
        <meta 
          name="description" 
          content="Book an Innova for outstation from Pune with S9 Travels. Get affordable and luxury Innova cabs for long-distance trips. Private Innova for outstation travel, group travel, weekend getaways, and more. Book now!" 
        />
        
        {/* Inject JSON-LD Schema */}
        <script type="application/ld+json">
          {JSON.stringify(productSchema)}
        </script>
      </Helmet>
      
<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/35.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Bookinnovaforoutstationfrompune;